<nav class="navbar navbar-expand-lg bg-white border-bottom border-purple border-opacity-50 px-3 px-lg-4 py-3">
  <div class="container-fluid px-0 d-flex align-items-center gap-3 flex-wrap">
    <button
      v-if="!hide_hamburger"
      class="btn d-flex d-lg-none align-items-center justify-content-center p-0 border-0 bg-transparent"
      @click="$emit('toggle-sidebar')"
      aria-label="Open menu"
    >
      <i class="bi bi-list fs-3 text-dark"></i>
    </button>

    <div class="d-flex align-items-center gap-3 flex-grow-1 min-w-0 overflow-hidden">
      <nav class="ms-4 config-breadcrumbs" aria-label="Breadcrumb">
        <ol class="breadcrumb mb-0 align-items-center flex-nowrap">
          <li
            v-for="(item, index) in breadcrumbItems"
            :key="`${item.label}-${index}`"
            class="breadcrumb-item d-flex align-items-center"
            :class="{ active: item.current }"
            :aria-current="item.current ? 'page' : null"
          >
            <router-link
              v-if="isClickable(item) && !item.current"
              :to="item.to"
              class="text-decoration-none breadcrumb-link"
            >
              {{ item.label }}
            </router-link>
            <span v-else class="breadcrumb-current text-truncate">
              {{ item.label }}
            </span>
          </li>
        </ol>
      </nav>
    </div>

    <div class="ms-auto d-flex align-items-center gap-2 gap-lg-3">
      <div class="input-group d-none d-sm-flex config-search">
        <span class="input-group-text border-0 bg-light">
          <i class="bi bi-search text-secondary"></i>
        </span>
        <input
          type="text"
          class="form-control form-control-sm border-0 bg-light shadow-lg"
          placeholder="Search ...."
        />
      </div>

      <button
        v-if="is_admin_role"
        type="button"
        class="btn-link text-dark p-2 text-decoration-none border-0 bg-transparent"
        aria-label="Open X-Verdict workspace"
        title="Open X-Verdict workspace"
        @click="goToOnboardingSystem"
      >
        <i class="bi bi-grid-3x3-gap fs-5"></i>
      </button>

      <a href="#" class="btn-link text-dark p-2 text-decoration-none">
        <i class="bi bi-bell-fill fs-5 "></i>
      </a>
      <a href="#" class="btn-link text-dark p-2 text-decoration-none">
        <i class="bi bi-question-circle fs-5"></i>
      </a>
      <div v-if="organizationName" class="d-none d-md-flex flex-column align-items-end lh-sm">
        <span class="text-secondary text-xxs fw-semibold text-uppercase">Organization</span>
        <span class="text-dark text-xs fw-bold text-truncate config-navbar-org">{{ organizationName }}</span>
      </div>
      <PlatformSwitcher current_platform_id="workflow" />
      <button
        type="button"
        class="btn text-dark rounded-circle d-flex align-items-center justify-content-center config-avatar-button"
        data-bs-toggle="modal"
        data-bs-target="#user_profile_modal"
        aria-label="Open your profile"
        @click="open_profile_modal"
      >
        <i class="bi bi-person-fill fs-4"></i>
      </button>
    </div>
  </div>
</nav>

<div
  id="user_profile_modal"
  class="modal fade"
  tabindex="-1"
  aria-labelledby="user_profile_modal_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content bg-white rounded-4 border-0 shadow-lg">
      <div class="modal-header cute-header border-bottom-0">
        <div>
          <h5 id="user_profile_modal_label" class="modal-title text-white mb-1">My Profile</h5>
          <p class="text-white-50 text-xxs mb-0">Update your personal information</p>
        </div>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <form @submit.prevent="save_profile">
        <div class="modal-body p-4">
          <div v-if="profile_loading" class="text-center text-secondary py-4">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Loading profile...
          </div>

          <div v-else>
            <div v-if="profile_error" class="alert alert-danger text-xs" role="alert">
              {{ profile_error }}
            </div>
            <div v-if="profile_success" class="alert alert-success text-xs" role="status">
              {{ profile_success }}
            </div>

            <div class="row g-3">
              <div class="col-sm-6">
                <label for="profile_first_name" class="form-label text-xs">First name</label>
                <input id="profile_first_name" v-model="profile_form.first_name" class="form-control text-xs" type="text" required>
              </div>
              <div class="col-sm-6">
                <label for="profile_last_name" class="form-label text-xs">Last name</label>
                <input id="profile_last_name" v-model="profile_form.last_name" class="form-control text-xs" type="text" required>
              </div>
              <div class="col-12">
                <label for="profile_email" class="form-label text-xs">Email address</label>
                <input id="profile_email" v-model="profile_form.email" class="form-control text-xs" type="email" required>
              </div>
              <div class="col-12">
                <label for="profile_phone_number" class="form-label text-xs">Phone number</label>
                <input id="profile_phone_number" v-model="profile_form.phone_number" class="form-control text-xs" type="tel">
              </div>
              <div class="col-sm-6">
                <label for="profile_sms_number" class="form-label text-xs">SMS number</label>
                <input id="profile_sms_number" v-model="profile_form.sms_number" class="form-control text-xs" type="tel">
              </div>
              <div class="col-sm-6">
                <label for="profile_whatsapp_number" class="form-label text-xs">WhatsApp number</label>
                <input id="profile_whatsapp_number" v-model="profile_form.whatsapp_number" class="form-control text-xs" type="tel">
              </div>
              <div class="col-12">
                <label for="profile_role" class="form-label text-xs">Role</label>
                <input id="profile_role" v-model="profile_form.role" class="form-control text-xs bg-light" type="text" readonly>
              </div>
            </div>

            <section v-if="isOrganizationAdmin" class="border-top mt-4 pt-4" aria-labelledby="profile_organization_heading">
              <h6 id="profile_organization_heading" class="text-xs fw-bold mb-2">Organization</h6>
              <div class="bg-light rounded-3 px-3 py-2 text-xs text-dark">
                <i class="bi bi-building me-2 text-secondary" aria-hidden="true"></i>
                {{ organizationName || 'Organization unavailable' }}
              </div>
            </section>
          </div>
        </div>

        <div class="modal-footer border-0 px-4 pb-4 pt-0">
          <button type="button" class="btn btn-outline-secondary btn-sm text-xs" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary-dark btn-sm text-xs" :disabled="profile_loading || profile_saving">
            <span v-if="profile_saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            {{ profile_saving ? 'Saving...' : 'Save changes' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

